export enum DisplayedFields {
  All = 0,
  Fifo = 1
}
